import React, { Fragment } from 'react'
import BookFVButton from './BookFVButton'
import { ButtonLink } from 'stylist'

const DesktopMenu = ({ isAuthenticated }) => (
  <Fragment>
    {isAuthenticated ? (
      <ButtonLink to="/logout" kind="ghost">
        Sign Out
      </ButtonLink>
    ) : (
      <Fragment>
        <ButtonLink to="/login" kind="ghost">
          Sign In
        </ButtonLink>
      </Fragment>
    )}
    <BookFVButton />
  </Fragment>
)

export default DesktopMenu



// WEBPACK FOOTER //
// ./src/routes/components/DesktopMenu.js